import React from "react";
import { useTranslation } from "react-i18next";
import {
  useCheckParticipationPhase,
  getPhaseOfDateRange,
  useAuthContext,
  useGlobalState,
} from "senf-shared";
import { Project, Survey } from "senf-shared/types";
import { useModals } from "../../molecules/modalStack/ModalProvider";
import Button from "../../core/button/Button";
import { useIsMobile } from "../../../hooks/customDeviceDetect";

export interface ParticipationModuleProps {
  variant?: "info";
  project?: Project;
  handle?: {
    addIdea?: () => void;
    openSurvey?: (surveyId: string) => void;
    openAddIdea?: (ideaMapId: string) => void;
    openMap?: () => void;
    openInfo?: () => void;
    openOrgainzation?: () => void;
    share?: () => void;
  };
  text?: string;
  viewType?: "overview" | "survey" | "ideaMap";
  handleNavigate?: () => void;
}
const ParticipationModule = ({
  variant,
  project,
  handle,
  text,
  viewType,
  handleNavigate
}: ParticipationModuleProps) => {
  const { t } = useTranslation();
  const [translation] = useGlobalState().translationsState;
  const { user } = useAuthContext();
  const { openModal } = useModals();
  const isMobile = useIsMobile();

  const getParticipationPhase = useCheckParticipationPhase();
  const { inactive, inactiveText } = getParticipationPhase(project, viewType);

 
  const surveyStatus = (survey: Survey, key?: string) =>
    user?.surveyEntries?.some(
      (entry: Survey) =>
        entry?.surveyMode !== "test" &&
        entry.surveyId === survey.surveyId &&
        ((key && entry[key]) || !key)
    );

  const surveyTitle = (survey: Survey, title?: string) =>
    surveyStatus(survey, "completed")
      ? t("survey:surveyAlreadyFilledOut")
      : surveyStatus(survey)
        ? t("survey:continueSurvey")
        : t("survey:takePartInSurvey");

  const handleOpenSurvey = (survey: Survey) => {
    if (surveyStatus(survey, "completed")) return;
    handle?.openSurvey?.(survey.surveyId);
  };

  const handleOpenModal = () => {

     // Check if there's only one ideaMap, no surveys, and the ideaMap doesn't allow posts
  if (project?.ideaMaps?.length === 1 && (!project?.surveys || project?.surveys?.length === 0)) {
    const onlyIdeaMap = project.ideaMaps[0];
    if (!onlyIdeaMap?.interactionOptions?.allowPosts) {
      handleNavigate?.();
      return;
    }
  }

    
    openModal(
      <div className="flex h-auto flex-col gap-3 overflow-scroll p-3  lg:p-6">
        {project?.ideaMaps?.map((ideaMap) => {
          console.log(ideaMap);

          const active =
            getPhaseOfDateRange(ideaMap.startDate, ideaMap.endDate) === "while";

          return (
            active &&
            ideaMap?.interactionOptions?.allowPosts &&
            ideaMap.settings?.publicAccess !== false && (
              <div className="flex flex-col items-start gap-3 rounded-xl p-4">
                <div className="flex flex-col gap-1">
                  <h3 className="heading-md">
                    {translation?.[ideaMap?.title] || ideaMap?.title}
                  </h3>
                  <p className="body-md">
                    {translation?.[ideaMap?.callToParticipate] ||
                      ideaMap?.callToParticipate}
                  </p>
                </div>
                <Button
                  trackId="projectroomInfoPage_openAddIdeaClick"
                  variant="primary"
                  size="lg"
                  leadingIcon="plus-md"
                  text={t("dialogMap:add.callToParticipateButton")}
                  onClick={() => handle?.openAddIdea(ideaMap)}
                />
              </div>
            )
          );
        })}

        {project?.surveys?.map((survey, index) => {
          const active =
            getPhaseOfDateRange(survey.startDate, survey.endDate) === "while";
          return active && survey?.settings?.publicAccess !== false ? (
            <div
              className="flex flex-col items-start gap-3 rounded-xl p-4"
              key={index}
            >
              <div className="flex flex-col gap-1">
                <h3 className="heading-md">
                  {translation?.[survey?.title] || survey?.title}
                </h3>
                <p className="body-md">
                  {translation?.[survey?.callToParticipate] ||
                    survey?.callToParticipate}
                </p>
              </div>
              <Button
                variant="primary"
                size="lg"
                text={surveyTitle(survey, survey.title)}
                trackId="projectroomInfoPage_openTakeSurveyClick"
                onClick={() => handleOpenSurvey(survey)}
                // leadingIcon="Stats"
                disabled={surveyStatus(survey, "completed")}
                disabledNotice={t("survey:surveyAlreadyFilledOut")}
              />
            </div>
          ) : null;
        })}
      </div>,
      {
        size: "lg",
        id: "participationModule",
        // title: "Jetzt teilnehmen",
        // description:
        //   "Du hast die Möglichkeit dich an der weiteren Planung zu beteiligen. Teile mit uns deine Meinungen und Ideen.",

        swipe: isMobile,
        zIndex: 99999999,
      }
    );
  };
  return (
    <Button
      variant="primary"
      size={variant === "info" && !isMobile ? "xl" : "lg"}
      text={inactive ? inactiveText : text || t("global:participateNow")}
      disabled={inactive}
      disabledNotice={inactiveText}
      className="[text-wrap:balance]"
      // pillShaped={!inactive}
      leadingIcon={!inactive ? "plus-md" : undefined}
      width={"max"}
      onClick={viewType === "ideaMap" ? handleNavigate : handleOpenModal}
    />
  );
};

export default ParticipationModule;
